<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15YTzk5/tc-custom/9781466887855.jpg?1718078973928" alt="This image is the cover for the book Crimea"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crimea
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The definitive history of the Crimean War from world-renowned historian Trevor Royle.<br/></b><br/>The Crimean War is one of history's most compelling subjects. It encompassed human suffering, woeful leadership and maladministration on a grand scale. It created a heroic myth out of the disastrous Charge of the Light Brigade and, in Florence Nightingale, it produced one of history's great heroes. New weapons were introduced; trench combat became a fact of daily warfare outside Sebastopol; medical innovation saved countless soldiers' lives that would otherwise have been lost. The war paved the way for the greater conflagration which broke out in 1914 and greatly prefigured the current situation in Eastern Europe.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Trevor Royle
      </h2>
      
      <p class="authorDescription body article"><B>Trevor Royle</B> is Associate Editor of the <I>Sunday Herald</I> and a regular commentator on international affairs for BBC radio. He is the author of <I>Crimea: The Great Crimean War, 1854-1856</I>, <I>Lancaster Against York: The Wars of the Roses and the Foundation of Modern Britain</I>, and contributed <I>Montgomery: Lessons in Leadership from the Soldier’s General</I> to the World Generals Series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fd6eb3fa